import React, { Component } from 'react'
import { addToCard, checkTranslation, imageAddress, translate } from '../../utils/useful';
// import Responsive from '../../components/Responsive';
// import HttpServices from '../../utils/Http.services';
// import { priceStandardView } from '../../utils/useful';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// import CustomLoader from '../../components/CustomLoader';
// import HelpButton from '../../components/HelpButton';
// import CommerceInvoiceCalculations from '../../components/CommerceInvoiceCalculations';
import StagesManager from '../../components/StagesManager';
import CartCheckout from './CartCheckout';
import CartDelivery from './CartDelivery';
import CartPayment from './CartPayment';
import HttpServices from '../../utils/Http.services';
import CartSuccess from './CartSuccess';


export class CommerceCart extends Component {
    state = {
        showCollapse: null,
        active: false,
        isLoading: {},
        // taxes: [{ _id: 1, title: 'GST/HST', percentage: 7, help: 'This is a test description about this tax' }, { _id: 0, title: 'PST/RST/QST', percentage: 5, help: 'This is a test description about this tax' }],
        paymentIntent: {}
    }

    componentDidMount() {
        this.setState({ currentIndex: 0 })

        if (this.props.setHeader) {

            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.props.changePage('')

            })
        }

        setTimeout(() => {
            if (this.props.carts?.applets == null || this.props.carts?.applets[this.props.variables?.appletId] == null) {
                this.getCart()
            }
        }, 100);


    }

    getCart = () => {

        let body = {
            hub: this.props.variables?.targetHub,
            applet: this.props.variables.appletId
        }
        this.setState({ isLoading: true })
        HttpServices.request('getCart', body, (fetchResult, fetchError) => {

            this.setState({ isLoading: false })


            if (fetchError) {

                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }

            if (fetchResult.info) {

                this.props.actions.setCart(fetchResult.info)

            }
        })

    }


    changePage = (page, link) => {
        this.props.changePage(page)
        this.props.changeWindowLink(link)
    }


    addToCart = (action, count, item, index) => {
        let applet = this.props.variables?.appletId
        let hub = this.props.variables?.targetHub

        let variants = item.variants
        let additionals = item.additionals
        let isLoading = this.state.isLoading
        isLoading[index] = true
        let product = typeof item.product == 'object' ? item.product?._id : item.product
        this.setState({ isLoading })
        addToCard(applet, hub, product, action, count, variants, additionals, () => {
            delete isLoading[index]
            this.setState({ isLoading })

        })
    }


    goToProduct = (props) => {
        this.props.changePage(['product', props.product._id])
    }

    successPayment = (info, cb) => {
        this.setState({ paymentIntent: info }, () => {
            if (cb) {
                cb()
            }
        })
    }

    render() {
        // let colors = this.props.colors
        // let background = `linear-gradient(90deg, ${colors?.primaryColor}, ${colors?.secondaryColor})`

        // let cart = {}
        // if (this.props.carts?.applets) {
        //     cart = this.props.carts?.applets[this.props.variables?.appletId]
        // }

        return (
            <div className='w-100  h-100 d-flex flex-column ' style={{ backgroundColor: "#f6f6f6", overflow: 'hidden' }}>

                <StagesManager height={'100%'} ref={el => this.stageManager = el} fast={true}>

                    <CartCheckout stageName={'cart'} stage={0} language={this.props.language} getCart={this.getCart} addToCart={this.addToCart} cart={this.state.cart} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} user={this.props.user} setUser={this.setUser} changeWindowLink={this.changeWindowLink} addNotif={this.addNotif} history={this.props.history} route={this.props.route} variables={this.props.variables} />
                    <CartDelivery stageName={'delivery'} language={this.props.language} windowData={this.props.windowData} cart={this.state.cart} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} changeWindowLink={this.changeWindowLink} addNotif={this.addNotif} history={this.props.history} route={this.props.route} variables={this.props.variables} />
                    <CartPayment stageName={'payment'} language={this.props.language} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} changeWindowLink={this.changeWindowLink} addNotif={this.addNotif} history={this.props.history} route={this.props.route} variables={this.props.variables} successPayment={this.successPayment} />
                    <CartSuccess stageName={'success'} language={this.props.language} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} changeWindowLink={this.changeWindowLink} addNotif={this.addNotif} history={this.props.history} route={this.props.route} variables={this.props.variables} paymentIntent={this.state.paymentIntent} />

                </StagesManager>
            </div>
        )
    }
}



const mapStateToProps = state => ({ carts: state.carts, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CommerceCart);